import { TRACK_IDS } from "../../../analytics/trackIds";
import React, { useEffect, useRef, useState } from "react";
import OpenFullScreenIcon from "../../../assets/icons/svg/OpenFullScreenIcon";
import localizationStrings from "../../../statics/localization";

export default function FullscreenButton({ player, setFullscreen }) {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const onChange = useRef(setFullscreen);
  onChange.current = setFullscreen;
  useEffect(() => {
    const sync = () => {
      const active = player.isFullscreen();
      setIsFullscreen(active);
      if (onChange.current) onChange.current(active);
    };
    sync();
    player.on("fullscreenchange", sync);
    return () => player.off("fullscreenchange", sync);
  }, [player]);
  return (
    <button
      type="button"
      data-track-id={TRACK_IDS.PLAYER_FULLSCREEN}
      className="control-button"
      aria-pressed={isFullscreen}
      title={
        isFullscreen
          ? localizationStrings.playerOptions.offFullscreen
          : localizationStrings.playerOptions.onFullscreen
      }
      onClick={() => {
        const result = player.isFullscreen()
          ? player.exitFullscreen()
          : player.requestFullscreen();
        // State follows fullscreenchange, including Escape and rejected requests.
        if (result && result.catch) result.catch(() => {});
      }}
    >
      <OpenFullScreenIcon />
    </button>
  );
}
